import styles from './index.module.css'

import React from 'react'
import * as AccordionPrimitive from '@radix-ui/react-accordion'
import { ChevronDownIcon } from '@radix-ui/themes'
import classNames from 'clsx'

export const Root = AccordionPrimitive.Root
export const Item = AccordionPrimitive.Item
export const Header = AccordionPrimitive.Header

export const Trigger = React.forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> & {
    icon?: React.ReactNode
  }
>(({ children, className, icon, ...props }, forwardedRef) => (
  <AccordionPrimitive.Header className={styles.AccordionHeader}>
    <AccordionPrimitive.Trigger
      className={classNames(styles.AccordionTrigger, className)}
      {...props}
      ref={forwardedRef}
    >
      <div className={styles.AccordionTriggerContent}>
        {icon && <span className={styles.AccordionIcon}>{icon}</span>}
        {children}
      </div>
      <ChevronDownIcon className={styles.AccordionChevron} aria-hidden />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
))

Trigger.displayName = 'AccordionTrigger'

export const Content = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ children, className, ...props }, forwardedRef) => (
  <AccordionPrimitive.Content
    className={classNames(styles.AccordionContent, className)}
    {...props}
    ref={forwardedRef}
  >
    {children}
  </AccordionPrimitive.Content>
))

Content.displayName = 'AccordionContent'

const Accordion = {
  Root,
  Item,
  Header,
  Trigger,
  Content,
}

export default Accordion
